function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.050781 0 L 22.949219 0 C 25.1875 0 27 1.8125 27 4.050781 L 27 22.949219 C 27 25.1875 25.1875 27 22.949219 27 L 4.050781 27 C 1.8125 27 0 25.1875 0 22.949219 L 0 4.050781 C 0 1.8125 1.8125 0 4.050781 0 Z M 4.050781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,72.156863%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 15.820312 7.382812 L 13.5 11.445312 L 11.179688 7.382812 L 3.375 7.382812 L 13.5 24.945312 L 23.625 7.382812 Z M 15.820312 7.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.784314%,28.627451%,36.862745%)",
      fillOpacity: 1
    },
    d: "M 15.820312 7.382812 L 13.5 11.445312 L 11.179688 7.382812 L 7.4375 7.382812 L 13.5 17.929688 L 19.5625 7.382812 Z M 15.820312 7.382812 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.1a4eeb133e857e6bab812245fe803f67.svg";
export { ForwardRef as ReactComponent };